export default class JsOverlayTrigger {
	static classname = 'js-overlay-trigger';

	constructor() {
		this.bindObserver();
	}

	bindObserver() {
		this.observer = new MutationObserver(this.handleMutations);

		this.observer.observe(document, {
			childList: true,
			subtree: true
		});
	}

	hasChildTrigger(node) {
		if (node.classList && node.classList.contains(JsOverlayTrigger.classname)) {
			return true;
		}

		if (!node.childNodes.length) {
			return false;
		}

		return Array.from(node.childNodes).some(child_node => this.hasChildTrigger(child_node));
	}

	select$Trigger(node) {
		return $(node).select(`.${JsOverlayTrigger.classname}`);
	}

	handleMutations = mutations => {
		mutations.forEach(mutation => {
			if (mutation.type !== 'childList') {
				return;
			}

			if (mutation.removedNodes.length) {
				for (let i = 0; i < mutation.removedNodes.length; i++) {
					const node = mutation.removedNodes[i];
					if (this.hasChildTrigger(node)) {
						this.handleTriggerRemove(node);
						return;
					}
				}
			}

			if (mutation.addedNodes.length) {
				for (let i = 0; i < mutation.addedNodes.length; i++) {
					const node = mutation.addedNodes[i];
					if (this.hasChildTrigger(node)) {
						this.handleTriggerAdd(node);
						return;
					}
				}
			}
		});
	};

	handleTriggerAdd = node => {
		const $trigger = this.select$Trigger(node);
		const classname = $trigger.data('classname');
		const container_selector = $trigger.data('container');
		const $container = $(container_selector);
		const insert_mode = $trigger.data('insert-mode');

		const $overlay = $('<div/>').attr('class', classname);
		$overlay[insert_mode === 'prepend' ? 'prependTo' : 'appendTo']($container);
	};

	handleTriggerRemove = node => {
		const $trigger = this.select$Trigger(node);
		const classname = $trigger.data('classname');
		const container_selector = $trigger.data('container');
		const $container = $(container_selector);

		$container.find(`.${classname}`).remove();
	};
};
